import './Style.css'
import * as React from "react";
import {ReactNode} from "react";



import {FBFieldBaseOptions, FieldTypeEnum} from "./Fields/Core/FBFieldBase.options";
import {GetFieldOptions} from "FormBuilder/Events/GetFieldOptions";
import {GetField} from "FormBuilder/Events/GetField";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {GetModel} from "FormBuilder/Events/GetModel";
import {EventManager} from "shared/core/Events/EventManager";

export class FieldFactory {
    public  static GetField(model:FBFieldBaseModel):ReactNode{



        let field=EventManager.Publish(new GetField(model));
        if(field!=null)
            return field as any;


        throw new Error('Invalid field '+model.Options.Type);
        return null;

    }


    public static GetFieldOptions(options:string|FBFieldBaseOptions):FBFieldBaseOptions
    {
        let type:string;
        if(options instanceof FBFieldBaseOptions)
            type=options.Type;
        else {
            type = options;
            options=null;
        }
        let fieldOptions:FBFieldBaseOptions=null;


        if(fieldOptions==null)
        {
            fieldOptions=EventManager.Publish(new GetFieldOptions(type as any));

        }

        if(fieldOptions==null)
        {
            throw new Error('Invalid field options '+type);
        }

        fieldOptions.Merge(options);
        return fieldOptions;

    }


    public static GetFieldModel(parent:FBColumnModel,options:FBFieldBaseOptions,previousData:any=null):FBFieldBaseModel
    {
        let model=EventManager.Publish(new GetModel(parent,options,previousData));
        if(model==null)
            throw new Error('Invalid model '+options.Type);

        return model;

    }


}